export const FINAL_VIDEO_ID = "PVsvSsABQZ4";

export const STAGES = [
  {
    id: 1,
    code: "friends",
    videoId: "hiADHw5k62E",
    hint: {
      type: "video",
      videoId: "ZpG7FIsAy9o",
    },
  },
  {
    id: 2,
    code: "stomach",
    videoId: "JZZRbn8erAk",
    hint: {
      type: "text",
      content: "Your Friendly Animals are Stuffed (Within a Box)...",
    },
  },
  {
    id: 3,
    code: "professionalchef",
    videoId: "jzB21s2-Zt4",
    hint: {
      type: "text",
      content:
        "It's in the freezer? https://www.allrecipes.com/recipe/13107/miso-soup/",
    },
  },
  {
    id: 4,
    code: "bulldogs",
    videoId: "Ja-Yb9ChicA",
    hint: {
      type: "text",
      content: "Go to where you cook and look up lol",
    },
  },
  {
    id: 5,
    code: "genki",
    videoId: "0LWDIS9lM8A",
    hint: {
      type: "text",
      content: "It might be behind a 'Bulldogs' themed emotion chart?",
    },
  },
  {
    id: 6,
    code: "girl",
    videoId: "Cg25-XI9pac",
    hint: {
      type: "text",
      content:
        "The couterpart to this machine is a Laundry Dryer ...and you might need to look behind it ;)",
    },
  },
  {
    id: 7,
    code: "engaged",
    videoId: "R2wa6P4soK0",
    hint: {
      type: "text",
      content: "The code is 'ENGAGED'",
    },
  },
  {
    id: 8,
    code: "done",
    videoId: "GvzwtYyG8nY",
    hint: {
      type: "text",
      content:
        "Look inside!!!!!!!!!!!!!! https://photos.app.goo.gl/PE6KNDSZBDYJoLEb6",
    },
  },
];
